import { AppBar, styled } from '@mui/material';
import theme from '../../theme/theme';

const StyledAppBar = styled(AppBar)({
  background: theme.palette.secondary.contrastText,
  color: theme.palette.secondary.mobileActiveToggleBackground,
  padding: 0,
});
export default StyledAppBar;
